if ( typeof CartForm !== 'function' ) {
	class CartForm extends HTMLElement {

		constructor(){
			super();
			this.ajaxifyCartItems();
		}

		ajaxifyCartItems(){

			this.form = this.querySelector('form');

			this.querySelectorAll('[data-js-cart-item]').forEach(item=>{

				const remove = item.querySelector('.remove');
				if ( remove ) {
					remove.dataset.href = remove.getAttribute('href');
					remove.setAttribute('href', '');
					remove.addEventListener('click', (e)=>{
						e.preventDefault();
						this.updateCartQty(item, 0);
					})
				}

				const qty = item.querySelector('.qty');
				if ( qty ) {
					qty.addEventListener('input', debounce(e=>{
						e.preventDefault();
						e.target.blur();
						this.updateCartQty(item, parseInt(qty.value));
					}, 500));
					qty.addEventListener('click', (e)=>{
						e.target.select();
					})
				}

			})

		}

		updateCartQty(item, newQty) {

		let alert = null;
		this.form.classList.add('processing');

		if (this.querySelector('.alert')) {
			this.querySelector('.alert').remove();
		}

		const body = JSON.stringify({
			line: parseInt(item.dataset.line),
			quantity: newQty
		});

		fetch(KROWN.settings.routes.cart_change_url, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
			body
		})
			.then(response => response.json())
			.then(response => {
			if (response.status == 422) {
				alert = document.createElement('span');
				alert.classList.add('alert', 'alert--error');
				alert.innerHTML = typeof response.description === 'string'
				? response.description
				: response.message;
			}

			return fetch('?section_id=helper-cart');
			})
			.then(response => response.text())
			.then(text => {
			const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
			const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
			const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

			const cartItems = document.getElementById('AjaxCartForm');
			cartItems.innerHTML = cartFormInnerHTML;
			cartItems.ajaxifyCartItems();

			document.querySelectorAll('[data-header-cart-count]').forEach(elm => {
				elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
			});
			document.querySelectorAll('[data-header-cart-total]').forEach(elm => {
				elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
			});

			if (alert !== null) this.form.prepend(alert);
			document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;

			document.dispatchEvent(new Event('cart-updated'));

			
			// === FREE SAMPLE / THRESHOLD LOGIC ===
			const totalWrapper = document.getElementById('free-sample-cart');
			const totalPriceElement = document.getElementById('get-total-price');
			const messageBox = document.getElementById('free-sample-message');
			const priceElement = document.getElementById('free-sample-price');

			if (totalWrapper && totalPriceElement) {

				const rawPrice = parseInt(totalPriceElement.getAttribute('get-total-price'));
				const unlock1 = parseInt(totalWrapper.getAttribute('data-threshold'));
				const unlock2 = parseInt(totalWrapper.getAttribute('data-threshold2'));
				totalWrapper.setAttribute('data-cart-price', rawPrice);

				// === PRODUCT UNLOCK DISPLAY ===
				const sampleProducts = document.querySelectorAll('.sample-product');

				sampleProducts.forEach((product, i) => {
					const button = product.querySelector('.sample-add-btn');
					const unlockAmount = (i === 0) ? unlock1 : unlock2;

					product.classList.remove('locked', 'unlocked');

					if (rawPrice >= unlockAmount) {
						product.classList.add('unlocked');
						if (button) button.disabled = false;
					} else {
						product.classList.add('locked');
						if (button) button.disabled = true;
					}
				});

				// === UPDATE REMAINING MESSAGE ===
				if (messageBox && priceElement) {
					let remaining = 0;

					if (rawPrice < unlock1) {
						remaining = unlock1 - rawPrice;
					} else if (rawPrice < unlock2) {
						remaining = unlock2 - rawPrice;
					} else {
						messageBox.style.display = 'none';
					}

					if (remaining > 0) {
						const formattedRemaining = (remaining / 100).toLocaleString('nl-NL', {
							style: 'currency',
							currency: 'EUR'
						});
						priceElement.textContent = formattedRemaining;
						messageBox.style.display = 'block';
					}
				}

				
// ZERO DELAY AUTO REMOVE
const FIRST_SAMPLE_VARIANTS = [56103824228687, 56103824294223, 56103824261455, 56501053981007, 56501054013775, 56501054046543];
const SECOND_SAMPLE_VARIANTS = [53936243474767, 53936243605839, 53936243540303];

let removeFirst = false;
let removeSecond = false;

if (rawPrice < 9000) {  
    removeFirst = true;
    removeSecond = true;
} else if (rawPrice < 12000) { 
    removeSecond = true;
}

if (removeFirst || removeSecond) {
    fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
        const itemsToRemove = cart.items.filter(item =>
            (removeFirst && FIRST_SAMPLE_VARIANTS.includes(item.variant_id)) ||
            (removeSecond && SECOND_SAMPLE_VARIANTS.includes(item.variant_id))
        );

        if (!itemsToRemove.length) return;

        // Remove from DOM and reset UI
        itemsToRemove.forEach(item => {
            const productEl = document.querySelector(`.sample-product[data-product-id="${item.product_id}"]`);
            if (productEl) {
                productEl.dataset.selected = "false";
                productEl.classList.add("locked");
                productEl.classList.remove("unlocked");

                const badge = productEl.querySelector('.sample-checked');
                if (badge) badge.style.display = 'none';

                const btn = productEl.querySelector('.sample-add-btn');
                if (btn) {
                    btn.textContent = '{{ "cart_drawer.sample_button_text" | t }}';
                    btn.disabled = true;
                }
            }

            const domItem = document.querySelector(`[data-id="${item.key}"]`);
            if (domItem) domItem.remove();
        });

        // Remove from selectedSampleIds and localStorage
        const removedIds = itemsToRemove.map(i => String(i.product_id));
        selectedSampleIds = selectedSampleIds.filter(id => !removedIds.includes(id));
        localStorage.setItem('selectedSampleIds', JSON.stringify(selectedSampleIds));

        // Update subtotal visually
        let subtotal = rawPrice;
        itemsToRemove.forEach(item => subtotal -= item.final_line_price);
        const subtotalEl = document.querySelector('[data-cart-total]');
        if (subtotalEl) {
            subtotalEl.textContent = (subtotal / 100).toLocaleString('nl-NL', { style: 'currency', currency: 'EUR' });
        }

        // Update header cart count
        const headerCount = document.querySelectorAll('[data-header-cart-count]');
        headerCount.forEach(el => el.textContent = cart.item_count - itemsToRemove.length);

        // Send removal request to Shopify
        const reqs = itemsToRemove.map(item =>
            fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: item.key, quantity: 0 })
            })
        );

        Promise.all(reqs).then(() => {
            // Update UI AFTER removal with correct subtotal
            updateSampleUI(subtotal);
        });
    });

    return; // Stop further processing
}

			}
			})
			.catch(e => {
				console.log(e);
				let alert = document.createElement('span');
				alert.classList.add('alert', 'alert--error');
				alert.textContent = KROWN.settings.locales.cart_general_error;
				this.form.prepend(alert);
			})
			.finally(() => {
				this.form.classList.remove('processing');
			});
		}


	}


  if ( typeof customElements.get('cart-form') == 'undefined' ) {
		customElements.define('cart-form', CartForm);
	}

}

if ( typeof CartProductQuantity !== 'function' ) {

	class CartProductQuantity extends HTMLElement {
		constructor(){
			super();
			this.querySelector('.qty-minus').addEventListener('click', this.changeCartInput.bind(this));
			this.querySelector('.qty-plus').addEventListener('click', this.changeCartInput.bind(this));
		}
		changeCartInput(){
			setTimeout(()=>{
				document.getElementById('AjaxCartForm').updateCartQty(this.closest('[data-js-cart-item]'), parseInt(this.querySelector('.qty').value));
			}, 50);
		}
	}

  if ( typeof customElements.get('cart-product-quantity') == 'undefined' ) {
		customElements.define('cart-product-quantity', CartProductQuantity);
	}

}

// method for apps to tap into and refresh the cart

if ( ! window.refreshCart ) {

	window.refreshCart = () => {
		
		fetch('?section_id=helper-cart')
			.then(response => response.text())
			.then(text => {

			const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
			const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
			const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

			const cartItems = document.getElementById('AjaxCartForm');
			cartItems.innerHTML = cartFormInnerHTML;
			cartItems.ajaxifyCartItems();

			document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
			});
			document.querySelectorAll('[data-header-cart-total]').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
			})
			
			document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
			if ( document.querySelector('[data-js-site-cart-sidebar]') ) {
				document.querySelector('[data-js-site-cart-sidebar]').show();
			}

			if ( document.querySelector('cart-recommendations') ) {
				document.querySelector('cart-recommendations').innerHTML = '';
				document.querySelector('cart-recommendations').generateRecommendations();
			}

		})

	}

}